"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageModel = exports.ImageRequestModel = exports.extractStorageDetails = void 0;
var class_validator_1 = require("class-validator");
exports.extractStorageDetails = function (image) {
    if (!image.original) {
        throw new Error("does not support derivate images");
    }
    try {
        var name_1 = image.name;
        var suffix = name_1.split(".").reverse()[0];
        var _a = name_1.split("/"), folder = _a[0], filename = _a[1];
        var basename = filename.split(".")[0];
        if (!suffix || !basename || !folder) {
            return null;
        }
        return {
            suffix: suffix,
            folder: folder,
            basename: basename,
        };
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
var fitTypes = ["cover", "contain", "fill", "inside", "outside"];
var fitTypesList = Array().concat(fitTypes);
var ImageRequestModel = /** @class */ (function () {
    function ImageRequestModel() {
        this.fit = "contain";
    }
    __decorate([
        class_validator_1.IsIn(fitTypesList),
        __metadata("design:type", String)
    ], ImageRequestModel.prototype, "fit", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], ImageRequestModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], ImageRequestModel.prototype, "width", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], ImageRequestModel.prototype, "height", void 0);
    return ImageRequestModel;
}());
exports.ImageRequestModel = ImageRequestModel;
var ImageModel = /** @class */ (function () {
    function ImageModel() {
        this.fit = "contain";
    }
    __decorate([
        class_validator_1.IsIn(fitTypesList),
        __metadata("design:type", String)
    ], ImageModel.prototype, "fit", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], ImageModel.prototype, "original", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], ImageModel.prototype, "width", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], ImageModel.prototype, "height", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ImageModel.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ImageModel.prototype, "path", void 0);
    return ImageModel;
}());
exports.ImageModel = ImageModel;
//# sourceMappingURL=ImageModel.js.map